const sizes = {
    dialogFontSize: '1.167rem',
    formFieldLabelFontSize: '1.167rem',
    linkFontSize: '1.167rem',
    textInputHeight: '3.333rem',
    textInputFontSize: '1.333rem',
    textInputBorderRadius: '8px',
    textInputSpacing: '0.666rem',
    textInputSpacingVariant1: '1rem',
    textInputWidthXL: '35rem',
    selectFieldInputWidth: '35rem',
};

export default sizes;
